<template>
  <div class="card card-custom gutter-b example example-compact">
    <div class="card-header">
      <div class="card-title">
        <h3>Posteingang</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="tabal-head-check-box">
        <div class="text-right"> 
          <v-btn @click="markSelectedAsRead" class="no-button mr-3"> Ausgewählte Elemente als gelesen markieren </v-btn>
        <v-btn @click="deleteInbox('selected', '0')" class="no-button"> Ausgewählte Elemente löschen </v-btn>
        </div>
        <div class="table-responsive mt-5">
          <v-simple-table class="record-table">
            <thead>
              <tr>
                <th class="text-center align-middle th-checkbox" width="5%">
                  <v-checkbox
                    v-model="allRecordsSelected"
                    @change="selectAllRecords"
                  ></v-checkbox>
                </th>
                <th class="text-center align-middle" width="10%">Seriennummer</th>
                <th width="20%" class="text-center align-middle">Von</th>
                <th width="30%" class="text-center align-middle">
                  Benachrichtigung
                </th>
                <th width="20%" class="text-center align-middle">Datum</th>
                <th class="text-center align-middle" width="15%">Aktionen</th>
              </tr>
            </thead>
            <tr>
              <td></td>
              <td></td>
              <td>
                <div>
                  <div class="search-input-div">
                    <v-text-field
                      dense
                      autocomplete="new-password"
                      v-model.lazy="searchNameKey"
                      solo
                      label="Name suchen..."
                      clearable
                    ></v-text-field>
                  </div>
                </div>
              </td>
              <td>
                <div class="search-input-div">
                  <v-text-field
                    dense
                    autocomplete="new-password"
                    v-model.lazy="searchNotificationKey"
                    solo
                    label="Benachrichtigung suchen..."
                    clearable
                  ></v-text-field>
                </div>
              </td>
              <td>
                <div class="search-input-div">
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model.lazy="searchDateKey"
                        solo
                        label="Suchdatum..."
                        clearable
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="searchDateKey" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
              </td>
              <td></td>
            </tr>
            <tbody v-if="inboxes.length">
              <tr v-for="(inbox, i) in inboxes" :key="inbox.id">
                <td class="align-middle">
                  <v-checkbox v-model="inbox.selected"></v-checkbox>
                </td>
                <td
                  class="align-middle clickable-td"
                  @click="goToDetails(inbox.id)"
                >
                  <span v-if="inbox.is_read == 0"
                    ><b>{{ i + 1 }}</b></span
                  >
                  <span v-else>{{ i + 1 }}</span>
                </td>
                <td
                  v-if="inbox.users"
                  class="align-middle clickable-td"
                  @click="goToDetails(inbox.id)"
                >
                  <span v-if="inbox.is_read == 0"
                    ><b>{{
                      inbox.users.first_name === "Admin" ? "Admin" : inbox.users.first_name + " " + inbox.users.last_name
                    }}</b></span
                  >
                  <span v-else>
                    {{ inbox.users.first_name === "Admin" ? "Admin" : inbox.users.first_name + " " + inbox.users.last_name }}
                  </span>
                </td>
                <td
                  v-else
                  class="align-middle text-center clickable-td"
                  @click="goToDetails(inbox.id)"
                >
                  <span>-</span>
                </td>
                <td
                  class="align-middle clickable-td"
                  @click="goToDetails(inbox.id)"
                >
                  <span v-if="inbox.is_read == 0"
                    ><b>{{ inbox.message.substr(0, 50) + "..." }}</b></span
                  >
                  <span v-else>{{  inbox.message.substr(0, 50) + "..." }}</span>
                </td>
                <td
                  class="align-middle clickable-td"
                  @click="goToDetails(inbox.id)"
                >
                  <b v-if="inbox.is_read == 0">{{ inbox.created_at | DateFormat}}</b>
                  <span v-else>{{ inbox.created_at | DateFormat}}</span>
                </td>
                <td
                  class="align-middle text-center icon-wrapper-block"
                  width="15%"
                >
                  <a @click="deleteInbox('one', inbox.id)">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="trash"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Löschen</span>
                    </v-tooltip>
                  </a>
                </td>
              </tr>
            </tbody>
            <tbody v-if="loading_inboxes" class="loading-tbody">
              <td colspan="5">
                Wird geladen...
                <b-spinner variant="primary" label="Text Centered"></b-spinner>
              </td>
            </tbody>
            <tbody
              v-if="!inboxes.length && !loading_inboxes"
              class="loading-tbody"
            >
              <tr>
                <td colspan="5">Keine Einträge gefunden</td>
              </tr>
            </tbody>
          </v-simple-table>
          <div class="d-flex pagination-block">
            <b-pagination
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total-rows="pagination.paginationRows"
              prev-text="Voriges"
              next-text="Nächstes"
              first-number
              last-number
              @change="paginationChange"
            >
              <template #prev-text
                ><span
                  ><b-icon
                    icon="chevron-left"
                    aria-hidden="true"
                    rel="prev"
                  ></b-icon></span
              ></template>
              <template #next-text
                ><span
                  ><b-icon
                    icon="chevron-right"
                    aria-hidden="true"
                    rel="next"
                  ></b-icon></span
              ></template>
            </b-pagination>
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Bitte bestätigen
        </v-card-title>

        <v-card-text>
          <span
            >
            <!-- Are you sure to delete
            {{
              deleteType === "selected"
                ? "selected notifications?"
                : "this notification?"
            }} -->
            Sind sie sicher, dass sie löschen möchten?
            </span
          >
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            :disabled="disabledCancel"
            class="no-button"
            @click="hideModal"
          >
            Nein
          </v-btn>
          <v-btn
            type="submit"
            @click="deleteRecord(deleteRecordId)"
            ref="kt_form_submit_btn"
            class="yes-button"
            :loading="yesActionLoading"
          >
            Ja
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <notifications group="inbox" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import Notifications from "vue-notification";
import JwtService from "@/core/services/jwt.service";
import HtmlClass from "@/core/services/htmlclass.service";
import KTScrollTop from "@/components/admin/layout/extras/ScrollTop";
import Loader from "@/components/admin/layout/Loader.vue";
import moment from "moment";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import providerAPI from "@/api/provider";
Vue.use(Notifications);
export default {
  name: "Inbox",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      // show page loading
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      HtmlClass.init(this.layoutConfig());
      this.getInbox();
    }
  },
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      inboxes: [],
      allRecordsSelected: false,
      searchNameKey: "",
      searchNotificationKey: "",
      searchDateKey: "",
      loading_inboxes: true,
      yesActionLoading: false,
      disabledCancel: false,
      deleteDialog: false,
      deleteRecordId: [],
      deleteType: "",
      bulkActionBtnDisabled: true,
      filter: {
        orderCol: "id",
        orderBy: "desc",
      },
      pagination: {
        currentPage: 1,
        perPage: 20,
        paginationRows: "",
      },
    };
  },
  filters: {
    DateFormat: function (value) {
      return moment(String(value)).format("DD-MM-YYYY H:mm");
    },
  },
  watch: {
    searchNameKey: {
      handler: function (val, oldVal) {
        this.inboxes = [];
        this.loading_inboxes = true;
        this.getInbox();
      },
      deep: true,
    },
    searchNotificationKey: {
      handler: function (val, oldVal) {
        this.inboxes = [];
        this.loading_inboxes = true;
        this.getInbox();
      },
      deep: true,
    },
    searchDateKey: {
      handler: function (val, oldVal) {
        this.inboxes = [];
        this.loading_inboxes = true;
        this.getInbox();
      },
      deep: true,
    },
  },
  methods: {
    markSelectedAsRead() {
      let array = [];
      this.inboxes.forEach((item) => {
        if (item.selected) {
          array.push(item.id);
        }
      });
      providerAPI
        .readStatusUpdate({ id: array })
        .then((response) => {
          if (response.status == "success") {
            this.$notify({
              group: "inbox",
              type: "success",
              position: "bottom right",
              text: "Benachrichtigungen werden als erfolgreich gelesen markiert.",
              duration: 5000,
            });
            this.allRecordsSelected = false;
            this.getInbox();
          } else {
            this.$notify({
              group: "inbox",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "inbox",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 5000,
          });
        });
    },
    selectAllRecords() {
      this.inboxes.forEach((item) => {
        item.selected = this.allRecordsSelected ? true : false;
      });
    },
    hideModal() {
      this.statusDialog = false;
      this.yesActionLoading = false;
      this.deleteDialog = false;
    },
    goToDetails(id) {
      this.$router.push({ path: "/dealer/inbox/" + id });
    },
    paginationChange() {
      this.inboxes = [];
      this.loading_inboxes = true;
      setTimeout(() => {
        this.getInbox();
      }, 100);
    },
    getInbox() {
      let data = {
        user_id: this.currentUser.id,
        page: this.pagination.currentPage,
        per_page: this.pagination.perPage,
        search_from_name_field: this.searchNameKey,
        search_notification_field: this.searchNotificationKey,
        search_notifiacation_date_field: this.searchDateKey,
      };
      providerAPI
        .getInbox(data)
        .then((response) => {
          if (response.status == "success") {
            let array = [];
            response.data.forEach((item) => {
              array.push({ ...item, selected: false });
            });
            this.inboxes = array;
            this.pagination.paginationRows = response.count;
            this.loading_inboxes = false;
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          } else {
            this.loading_inboxes = false;
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.$notify({
              group: "inbox",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          this.loading_inboxes = false;
          this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          this.$notify({
            group: "inbox",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 5000,
          });
        });
    },
    deleteInbox(type, id) {
      switch (type) {
        case "selected":
          let array = [];
          this.inboxes.forEach((item) => {
            if (item.selected) {
              array.push(item.id);
            }
          });
          if (array.length) {
            this.deleteType = type;
            this.deleteDialog = true;
            this.deleteRecordId = array;
          }
          break;

        case "one":
          this.deleteType = type;
          this.deleteDialog = true;
          this.deleteRecordId.push(id);
          break;
      }
    },
    deleteRecord(id) {
      this.disabledCancel = true;
      this.yesActionLoading = true;
      providerAPI
        //.deleteNotification({ id: id })
        .deleteNotification({ id: id })
        .then((response) => {
          if (response.status == "success") {
            this.deleteDialog = false;
            this.deleteRecordId = [];
            this.disabledCancel = false;
            this.yesActionLoading = false;
            this.$notify({
              group: "inbox",
              type: "success",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
            this.pagination.currentPage = 1;
            this.getInbox();
          } else {
            this.deleteDialog = false;
            this.deleteRecordId = [];
            this.disabledCancel = false;
            this.yesActionLoading = false;
            this.$notify({
              group: "inbox",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          this.deleteDialog = false;
          this.deleteRecordId = [];
          this.disabledCancel = false;
          this.yesActionLoading = false;
          this.$notify({
            group: "inbox",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}

.invite-btn {
  background-color: #3d5a80 !important;
}

.invite-btn:hover {
  background-color: #002c47 !important;
}

table {
  text-align: center;
  font-size: 15px;
}

.new-btn-text {
  margin-left: 10px;
  font-size: 13px;
}

a {
  cursor: pointer;
}

.file-modal {
  padding: 0;
  margin: 0;
}

.modal-image {
  width: 100%;
}

.table-image {
  cursor: pointer;
  margin: 5px;
}

th {
  cursor: pointer;
}

.loading-tbody {
  text-align: center;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table__wrapper > table > thead > tr > th {
  font-size: 14px;
  height: 48px;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 14px;
  height: 48px;
}

.clickable-td {
  cursor: pointer;
}
</style>